// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/home.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/home-mobile.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background: #ffffff;
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 203, 230, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFFFFF", endColorstr="#C6CBE6", GradientType=1);
}

main {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
}
header{
    width: 100%;
    height: calc(100vh - 70px);

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    backdrop-filter: blur(2.5px);

    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;
    z-index: 999;
}

.header_logo {
    display: flex;
    align-items: center;
    gap: 10px;

    margin-left: 94px;
}

.header_logo img{
    width: 125px;
    height: 136px;

    border-radius: 20px;
}

.text-logo {
    color: #FFF;

    font-family: "Californian FB";

    display: flex;
    flex-direction: column;
    justify-content: center;
}

.text-logo h1{
    font-size: 63px;
    font-weight: 700;

    margin-bottom: 11px;
    margin-top: 0px;
}

.text-logo span{
    font-size: 26px;
    font-weight: 400;
}

.header_menu {
    display: flex;
    align-items: flex-start;

    margin-right: 100px;
}

.header_menu ul{
    list-style: none;

    padding: 0px;
    margin: 0px;
}

.header_menu ul a {
    color: white;

    text-decoration: none;
    font-family: 'Inter', sans-serif;
    font-size: 23px;
    font-weight: 400;
}

.header_menu ul li {
    width: 149px;

    border-radius: 0px 0px 0px 10px;
    border-bottom: 2px solid #FFF;
    border-left: 2px solid #FFF;

    padding: 0px 23px 5px 24px;

    margin-bottom: 19px;

    position: relative;
    left: -24px;
}

section {
    margin-top: 141px !important;

    height: auto;
}

.title-section{
    width: fit-content;

    font-family: "Inter";
    font-size: 45px;
    font-style: normal;
    font-weight: 300;

    margin-left: 2vw;

    border-bottom: solid 7px #E9C455;
}

.f-50 {
    font-size: 50px;
}
/*
Sobre
*/

.sub-text{
    text-align: center;
    font-family: "Inter";
    font-style: normal;
    line-height: normal;
    font-weight: 200;
}

.sub-text span{
    color: #E9C455;
    font-style: italic;

    font-weight: 500;
}

/*
Atuação
*/
.shadow-card {
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.33);
}



/*
Advogados
*/
.card-adv {
    border-radius: 33px;

    background: #FFF;

    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.33);
}

.card-adv .card-img-top{
    width: 157px;
    height: 200px;

    object-fit: cover;

    border-radius: 33px 10px;

    border: solid rgba(70, 70, 70, 0.562) 2px;
}

/*contatos*/
.bg-gradient-blue-white{
    background: linear-gradient(to left, #0A2747 80%, #FFFFFF 80%);
}

#contatos iframe{
    box-shadow: 0px 4px 22px 8px rgba(0, 0, 0, 0.33);
}

.text-contato{
    color: #FFF;
    font-family: "Inter";
    font-size: 22px;
    font-weight: 700;
}


/*
Medias Screen
*/

@media screen and (min-width: 650px) {
    .header_menu ul a:hover li:not(.active){
        color: #E9C455;
        border-bottom: 2px solid #E9C455;
        border-left: 2px solid #E9C455;
    }



}

@media screen and (max-width: 1020px) {
    header{
        flex-direction: column;
        justify-content: space-evenly;
    }


    .bg-gradient-blue-white {
        background: #0A2747;
    }

    .header_logo, .header_menu {
        margin: 0px;
    }
}

@media screen and (max-width: 650px) {
    header{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .f-50 {
        font-size: 10vw;
    }

    .text-logo h1 {
        font-size: 9vw;
    }
    .text-logo span {
        font-size: 4vw;
    }
    .header_logo img {
        width: 20vw;
        height: 20vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/onePage/OnePage.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IAGnB,0FAA0F;IAC1F,kHAAkH;AACtH;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,0BAA0B;;IAE1B,yDAA2C;IAC3C,4BAA4B;IAC5B,sBAAsB;IACtB,kCAAkC;;IAElC,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,mBAAmB;AACvB;;AAEA;IACI,WAAW;;IAEX,6BAA6B;;IAE7B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;;IAEvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;;IAEhB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;;IAEZ,qBAAqB;IACrB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;;IAEZ,+BAA+B;IAC/B,6BAA6B;IAC7B,2BAA2B;;IAE3B,0BAA0B;;IAE1B,mBAAmB;;IAEnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,4BAA4B;;IAE5B,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;;IAEhB,gBAAgB;;IAEhB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;AACA;;CAEC;;AAED;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;;IAElB,gBAAgB;AACpB;;AAEA;;CAEC;AACD;IACI,gDAAgD;AACpD;;;;AAIA;;CAEC;AACD;IACI,mBAAmB;;IAEnB,gBAAgB;;IAEhB,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,iBAAiB;;IAEjB,wBAAwB;;IAExB,yCAAyC;AAC7C;;AAEA,WAAW;AACX;IACI,8DAA8D;AAClE;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;;CAEC;;AAED;IACI;QACI,cAAc;QACd,gCAAgC;QAChC,8BAA8B;IAClC;;;;AAIJ;;AAEA;IACI;QACI,sBAAsB;QACtB,6BAA6B;IACjC;;;IAGA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yDAAkD;IACtD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["body{\n    background: #ffffff;\n    background: -webkit-linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 203, 230, 1) 100%);\n    background: -moz-linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 203, 230, 1) 100%);\n    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(198, 203, 230, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#FFFFFF\", endColorstr=\"#C6CBE6\", GradientType=1);\n}\n\nmain {\n    width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n}\nheader{\n    width: 100%;\n    height: calc(100vh - 70px);\n\n    background-image: url('../../img/home.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n\n    backdrop-filter: blur(2.5px);\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    position: relative;\n    z-index: 999;\n}\n\n.header_logo {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    margin-left: 94px;\n}\n\n.header_logo img{\n    width: 125px;\n    height: 136px;\n\n    border-radius: 20px;\n}\n\n.text-logo {\n    color: #FFF;\n\n    font-family: \"Californian FB\";\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.text-logo h1{\n    font-size: 63px;\n    font-weight: 700;\n\n    margin-bottom: 11px;\n    margin-top: 0px;\n}\n\n.text-logo span{\n    font-size: 26px;\n    font-weight: 400;\n}\n\n.header_menu {\n    display: flex;\n    align-items: flex-start;\n\n    margin-right: 100px;\n}\n\n.header_menu ul{\n    list-style: none;\n\n    padding: 0px;\n    margin: 0px;\n}\n\n.header_menu ul a {\n    color: white;\n\n    text-decoration: none;\n    font-family: 'Inter', sans-serif;\n    font-size: 23px;\n    font-weight: 400;\n}\n\n.header_menu ul li {\n    width: 149px;\n\n    border-radius: 0px 0px 0px 10px;\n    border-bottom: 2px solid #FFF;\n    border-left: 2px solid #FFF;\n\n    padding: 0px 23px 5px 24px;\n\n    margin-bottom: 19px;\n\n    position: relative;\n    left: -24px;\n}\n\nsection {\n    margin-top: 141px !important;\n\n    height: auto;\n}\n\n.title-section{\n    width: fit-content;\n\n    font-family: \"Inter\";\n    font-size: 45px;\n    font-style: normal;\n    font-weight: 300;\n\n    margin-left: 2vw;\n\n    border-bottom: solid 7px #E9C455;\n}\n\n.f-50 {\n    font-size: 50px;\n}\n/*\nSobre\n*/\n\n.sub-text{\n    text-align: center;\n    font-family: \"Inter\";\n    font-style: normal;\n    line-height: normal;\n    font-weight: 200;\n}\n\n.sub-text span{\n    color: #E9C455;\n    font-style: italic;\n\n    font-weight: 500;\n}\n\n/*\nAtuação\n*/\n.shadow-card {\n    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.33);\n}\n\n\n\n/*\nAdvogados\n*/\n.card-adv {\n    border-radius: 33px;\n\n    background: #FFF;\n\n    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.33);\n}\n\n.card-adv .card-img-top{\n    width: 157px;\n    height: 200px;\n\n    object-fit: cover;\n\n    border-radius: 33px 10px;\n\n    border: solid rgba(70, 70, 70, 0.562) 2px;\n}\n\n/*contatos*/\n.bg-gradient-blue-white{\n    background: linear-gradient(to left, #0A2747 80%, #FFFFFF 80%);\n}\n\n#contatos iframe{\n    box-shadow: 0px 4px 22px 8px rgba(0, 0, 0, 0.33);\n}\n\n.text-contato{\n    color: #FFF;\n    font-family: \"Inter\";\n    font-size: 22px;\n    font-weight: 700;\n}\n\n\n/*\nMedias Screen\n*/\n\n@media screen and (min-width: 650px) {\n    .header_menu ul a:hover li:not(.active){\n        color: #E9C455;\n        border-bottom: 2px solid #E9C455;\n        border-left: 2px solid #E9C455;\n    }\n\n\n\n}\n\n@media screen and (max-width: 1020px) {\n    header{\n        flex-direction: column;\n        justify-content: space-evenly;\n    }\n\n\n    .bg-gradient-blue-white {\n        background: #0A2747;\n    }\n\n    .header_logo, .header_menu {\n        margin: 0px;\n    }\n}\n\n@media screen and (max-width: 650px) {\n    header{\n        background-image: url(\"../../img/home-mobile.jpg\");\n    }\n\n    .f-50 {\n        font-size: 10vw;\n    }\n\n    .text-logo h1 {\n        font-size: 9vw;\n    }\n    .text-logo span {\n        font-size: 4vw;\n    }\n    .header_logo img {\n        width: 20vw;\n        height: 20vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
